<script setup lang="ts">
import { Headset } from 'lucide-vue-next'
import useContentScope from '@/composables/contentScope'
import type { ContentCreator } from '@/types/contentScope'

const props = defineProps<{
  creator: ContentCreator | null | undefined
}>()

const { t } = useI18n()
const { currentUserId } = useContentScope()

const isMe = computed(() => !!props.creator && !props.creator.support && props.creator.id === currentUserId.value)

const name = computed(() => props.creator?.name || t('contentScope.creator.unknown'))
</script>

<template>
  <span
    v-if="creator?.support"
    class="inline-flex items-center gap-1.5 text-sm text-foreground-secondary"
    data-testid="content-scope-creator"
  >
    <Headset class="size-3.5 shrink-0" aria-hidden="true" />
    {{ t('contentScope.creator.support') }}
  </span>
  <span
    v-else-if="creator"
    class="block max-w-[150px] truncate text-sm"
    :class="isMe ? 'font-medium text-foreground' : 'text-foreground-secondary'"
    :title="isMe ? undefined : name"
    data-testid="content-scope-creator"
  >
    {{ isMe ? t('contentScope.creator.you') : name }}
  </span>
</template>
